import api from "../axiosService";

export const getAllStandard = async () => {
  const res = await api.get("standard/getAllStandard");
  return res;
};
